import React from 'react'
import { Dialog } from 'antd-mobile'
import { Counter } from './Counter'
import { Packet2 } from './Packet2'
import { PacketList } from './PacketList'
import { Container, Header, Wrapper } from '../../components_renew/Layout'

export default class RedPacket extends React.PureComponent {

  state = {
    // 当场/下场红包池信息
    packetInfo: {},
    // 红包池列表
    packetList: []
  }

  listener

  componentDidMount () {
    this.getData()
    // this.addListen()
    document.title = '抢红包'
  }

  componentWillUnmount () {
    // this.removeListen()
    document.title = ''
  }

  // addListen = () => {
  //   // app切到后台返回后，须重新获取时间去count
  //   this.listener = listenMessage((message) => {
  //     if (message['type'] === window.POST_TYPE.PAGE_REFRESH && message['data'] === 'red-packet') {
  //       this.getData()
  //     }
  //   })
  // }

  // removeListen = () => {
  //   window.removeEventListener('message', this.listener)
  // }

  render () {
    let { packetInfo, packetList } = this.state
    return <Container className={'RP__container'}>
      <Header ghost/>
      <Wrapper flex transparent>
        <PacketList index={packetInfo['index']} packetList={packetList}/>
        <br/>
        <Counter
          timeStamp={packetInfo['timeStamp']}
          started={packetInfo['started']}
          onCountDown={this.onCountDown}
        />
        <Packet2 packetInfo={packetInfo}/>
      </Wrapper>
    </Container>
  }

  getData = (countdown = false) => {
    let config = {
      method: 'get',
      url: window.API.RedPacket.getPacketList,
      params: {
        platform: 'web',
        countdown,
        version: window.appInfo['VERSION']
      }
    }
    window.toast.show('')
    window.axios.request(config)
      .then((res) => {
        if (Array.isArray(res) && res['length'] > 0) {
          let moment = new window.moment(res[0]['nowTime'], 'x')
          // 下一场红包的obj
          let packetInfo = null
          // 查找下一场红包场次
          let packetList = res.map((item, index) => {
            let closeTime = item['closeTime'].split(':')
            let openTime = item['openTime'].split(':')
            let closeMoment = moment.clone().set({ hour: closeTime[0], minute: closeTime[1], second: 0 })
            let openMoment = moment.clone().set({ hour: openTime[0], minute: openTime[1], second: 0 })
            let newItem = {
              ...item,
              // moment(nowTime)
              moment,
              closeMoment,
              openMoment,
              // 判断
              started: moment.isAfter(openMoment),
              finished: moment.isAfter(closeMoment)
            }
            if (!packetInfo && moment.isBefore(closeMoment)) {
              packetInfo = newItem
              Object.assign(packetInfo, { index })
              // 若未开始，则增加timeStamp
              if (!packetInfo['started']) {
                Object.assign(packetInfo, { timeStamp: (openMoment.format('x') - item['nowTime']) })
                // Object.assign(packetInfo, { timeStamp: (3600) })
              } else {
                // 若开始，增加红包雨结束前的timeStamp
                Object.assign(packetInfo, { timeStamp: (closeMoment.format('x') - item['nowTime']) })
                // Object.assign(packetInfo, { timeStamp: (3600) })
              }
            } else {
              // ?
            }
            return newItem
          })
          // 处理本日已无可抢红包的情况
          if (!packetInfo) {
            packetInfo = { index: packetList.length - 1, todayOver: true }
            // Modal.alert('来晚啦！', '本日所有红包雨已结束，明天请早')
            Dialog.alert({
              title: '来晚啦！',
              content: '本日所有红包雨已结束，明天请早'
            })
            console.group('本日已无红包')
            console.log(packetList, packetInfo)
            console.groupEnd()
          }

          this.setState({
            packetInfo, packetList
          })
          window.toast.hide()
        } else {
          window.toast.info('暂无红包活动，请稍后再来~')
        }
      })
      .catch(error => {
        console.error(error)
        window.toast.fail(error.message)
      })
  }

  onCountDown = () => {
    console.log('count down')
    // setTimeout(this.getData, 0)
    this.getData(true)
    // window.location.reload()
  }

}
